export const formatNumber = (value) => {
  const num = Number(value);
  return isNaN(num) ? 0 : parseFloat(num.toFixed(3)).toString();
};